import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/auth/authentication.service';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = this.authService.token;

    if (token) {
      const baseHeaders = {
        Accept: 'application/json',
        Authorization: `Bearer ${this.authService.token}`,
      };

      if (!req.url.indexOf('/api/upload')) {
        req = req.clone({
          setHeaders: Object.apply({
            'Content-Type': 'application/json; charset=utf-8',
            baseHeaders,
          }),
        });
      } else {
        req = req.clone({
          setHeaders: baseHeaders,
        });
      }
    }

    return next.handle(req);
  }
}
